import Link from "next/link";

const SellerProducts = ({ seller, categories }) => {
  let productsCount = categories.reduce(
    (count, category) => count + category.product_count,
    0
  );

  return (
    <section className="my-14">
      <div className="my-6 md:flex">
        <h2 className="text-xl md:text-2xl lg:text-[34px] leading-26">
          Produse vandute de <span className="font-medium">{seller.name}</span>
        </h2>

        <p className="flex text-gray-light mt-[2px] leading-7 text-lg md:ml-4 md:text-xl lg:text-[28px]">
          <span className="hidden md:block mr-2">&#8226;</span>
          {productsCount}
        </p>
      </div>

      {categories.map((category) => (
        <div key={category.id}>
          <h2 className="font-medium text-22px leading-28.6 mt-8">
            {category.name}
          </h2>

          {category.subcategories?.length > 0 && (
            <div className="md:grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {category.subcategories.map((subcategory) => (
                <div key={subcategory.id} className="flex flex-col">
                  <Link
                    href={`/${subcategory.url_key}/cpl/filtru/seller-ids/${seller.id}-${seller.url_key}`}
                  >
                    <a className="text-base leading-28.6 mt-4">
                      {subcategory.name} ({subcategory.product_count})
                    </a>
                  </Link>

                  {subcategory?.subcategories?.map((subcategoryCategories) => (
                    <Link
                      key={subcategoryCategories.id}
                      href={`/${subcategoryCategories.url_key}/cpl/filtru/seller-ids/${seller.id}-${seller.url_key}`}
                    >
                      <a className="text-sm text-[#0094EB] leading-6 ml-4 mt-1">
                        {subcategoryCategories.name} (
                        {subcategoryCategories.product_count})
                      </a>
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default SellerProducts;
